import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import type { RootState } from "../store/store";
import { LOGINPAGE } from "../views/auth/routes";
import { isFinanceiroOrAdminFromToken } from "../utils/authToken";
import { isTokenValid } from "../utils/isTokenValid";
import { staffHomeFromToken } from "../utils/staffHome";

type Props = {
  children: React.ReactElement;
};

/**
 * Rotas do Financeiro: ADMIN, FINANCEIRO e FINANCEIRO_LEITURA, como papel
 * principal ou adicional (ADR 0024). Quem lê vê as mesmas telas sem os botões de
 * escrita (`useFinPermissions`).
 *
 * Papel sem acesso vai para a home DELE, não para o login — é falta de
 * permissão, não sessão vencida (mesmo critério do `DpRoute`).
 */
const FinanceiroRoute: React.FC<Props> = ({ children }) => {
  const rehydrated = useSelector((s: RootState) => !!(s as any)._persist?.rehydrated);
  const token = useSelector((s: RootState) => (s as any).auth?.accessToken);

  if (!rehydrated) return null;

  if (!isTokenValid(token)) return <Navigate to={LOGINPAGE()} replace />;

  if (!isFinanceiroOrAdminFromToken(token)) return <Navigate to={staffHomeFromToken(token)} replace />;

  return children;
};

export default FinanceiroRoute;
